
// window.addEventListener("load", (event) => {
//   document.querySelector('.cstm_sample_btn').addEventListener('click', function() {
//     // Get the current product price
//     let priceElement = document.querySelector('.price.price--product .price-item.price-item--regular');
//     let currentPrice = parseFloat(priceElement.textContent.replace('$', ''));

//     // Add 10$ to the current price
//     let newPrice = currentPrice + 10;
//     priceElement.textContent = `$${newPrice.toFixed(2)}`;

//     // Simulate clicking the "Add to Cart" button after 1 second
  
// });

//     setTimeout(function() {
//         document.querySelector('.cstm_add_to_cart').click();
//     }, 4000); // 1 second delay
// });


window.addEventListener("load", (event) => {

   const currentUrl = window.location.href;
    // Set the URL as the value of the input with id 'product-url'
    document.getElementById('product-url').value = currentUrl;
  
 const productTitleHTML = document.querySelector('.custom_product_title_main')?.innerHTML;
    
    if (productTitleHTML) {
        // Remove extra whitespace from the title
        const cleanTitle = productTitleHTML.replace(/\s+/g, ' ').trim();
        // Set the cleaned title as the value of the input with id 'product-title'
        document.getElementById('product-title').value = cleanTitle;
    }
  
  
  document.querySelector('.cstm_sample_btn').addEventListener('click', function(e) {

   
    
    e.preventDefault();
document.querySelector('#shopify-section-template--18505441771732__featured_product_fffJRg .product-form__buttons-row button[type="submit"]').click();
    
    
  });
});



